import { Typography } from '@/ui';

import type { FC } from 'react';

interface TextProps {
  text: string;
}

const Text: FC<TextProps> = ({ text }) => (
  // flex-1 + items-center centers the comment vertically between the slide header
  // and the footer; -mt-16 cancels the header's mb-16 so the two gaps are equal.
  // The quote mark is positioned against the comment, not the slide.
  <div className="-mt-16 flex w-full flex-1 items-center">
    <div className="relative w-full py-12">
      <div
        // eslint-disable-next-line tailwindcss/no-arbitrary-value -- One-off typography stylings for design purposes.
        className="pointer-events-none absolute left-4 z-0 select-none text-[215px] leading-[140px] text-bloom-200 md:top-6"
        aria-hidden
      >
        “
      </div>
      <Typography
        className="relative z-10 mx-auto max-w-4xl text-center md:px-12 xl:px-0"
        color="text.primary"
        variant="h4"
      >
        {text}
      </Typography>
    </div>
  </div>
);
export default Text;
